import type { ComponentPropsWithoutRef } from 'react';

import { buildSrc } from '@/integrations/image-kit';
import { cn } from '@/shared/utils/cn';

const aceImageUrl = buildSrc({
  src: '/duos-storage/ace.png',
  queryParameters: {
    updatedAt: '1764938807230',
  },
  transformation: [{ height: 350, dpr: 2 }],
});

export type AceCardImageProps = Omit<
  ComponentPropsWithoutRef<'img'>,
  'src' | 'alt'
>;

export function AceCardImage({ className, ...props }: AceCardImageProps) {
  return (
    <img
      src={aceImageUrl}
      alt="Duo Ace Card"
      className={cn('w-auto object-contain', className)}
      {...props}
    />
  );
}
